(function (global) {
  'use strict';
  var HISTORY_KEY = 'recentlyViewedProducts';
  // This is the existing Athens record. There is deliberately no second writer.
  function readRecent(storage, now) {
    try {
      var raw = storage().getItem(HISTORY_KEY);
      if (!raw || raw.length > 50000) return [];
      var records = JSON.parse(raw);
      if (!Array.isArray(records)) return [];
      var seen = new Set();
      return records.slice(-24).reverse().filter(function (entry) {
        if (!entry || !['string', 'number'].includes(typeof entry.id)) return false;
        var id = String(entry.id);
        if (!/^[1-9]\d{0,15}$/.test(id) || !Number.isSafeInteger(Number(id))) return false;
        if (typeof entry.timestamp !== 'number' || !Number.isFinite(entry.timestamp) || entry.timestamp <= 0 || entry.timestamp > now + 60000) return false;
        return true;
      }).sort(function (a, b) { return b.timestamp - a.timestamp; }).filter(function (entry) {
        var id = String(entry.id);
        if (seen.has(id)) return false;
        seen.add(id); return true;
      }).slice(0, 12).map(function (entry) { return String(entry.id); });
    } catch (error) { return []; }
  }
  function requestURL(searchURL, origin, ids) {
    if (!ids.length || ids.length > 12 || ids.some(function (id) { return !/^[1-9]\d{0,15}$/.test(id); })) return null;
    var url;
    try { url = new URL(searchURL, origin); } catch (error) { return null; }
    if (url.origin !== origin) return null;
    url.searchParams.set('section_id', 'sk-recent-search');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', ids.map(function (id) { return 'id:' + id; }).join(' OR '));
    return url.href;
  }
  function initHost(host, template, win) {
    if (host.__skHomeRecent) return host.__skHomeRecent;
    var doc = host.ownerDocument;
    var input = host.querySelector('input[type="search"]');
    if (!input) return null;
    var panel = template.content.firstElementChild.cloneNode(true);
    var links = panel.querySelector('[data-sk-recent-links]');
    var description = panel.querySelector('[data-sk-recent-description]');
    var listeners = [];
    var composing = false;
    var skipFocus = false;
    var requestId = 0;
    var controller;
    var requestTimer;
    var closeTimer;
    var describedBy = input.getAttribute('aria-describedby');
    var originalPlaceholder = input.getAttribute('placeholder');
    var serial = (win.__skHomeRecentSerial || 0) + 1;
    win.__skHomeRecentSerial = serial;
    description.id = 'SkRecentDescription-' + serial;
    host.classList.add('sk-home-recent-host');
    host.appendChild(panel);
    input.placeholder = '商品名・機種名・型番から探す';
    function on(node, name, fn, options) { node.addEventListener(name, fn, options); listeners.push(function () { node.removeEventListener(name, fn, options); }); }
    function hide() {
      requestId += 1;
      if (controller) controller.abort();
      win.clearTimeout(requestTimer);
      panel.hidden = true;
      host.classList.remove('sk-home-recent-open');
      if (describedBy === null) input.removeAttribute('aria-describedby');
      else input.setAttribute('aria-describedby', describedBy);
    }
    function focusInput() { skipFocus = true; input.focus({ preventScroll: true }); skipFocus = false; }
    function eligible() { return !composing && !input.value.trim() && doc.activeElement === input && host.isConnected; }
    async function show() {
      if (skipFocus || !eligible() || !panel.hidden) return;
      var ids = readRecent(function () { return win.localStorage; }, Date.now());
      if (!ids.length) { hide(); return; }
      var url = requestURL(template.dataset.searchUrl, win.location.origin, ids);
      if (!url) return;
      hide();
      var attempt = requestId;
      controller = new win.AbortController();
      var activeController = controller;
      requestTimer = win.setTimeout(function () { activeController.abort(); }, 8000);
      var activeTimer = requestTimer;
      try {
        var response = await win.fetch(url, { signal: activeController.signal, credentials: 'same-origin' });
        if (!response.ok) return;
        var markup = await response.text();
        if (attempt !== requestId || !eligible()) return;
        var parsed = new win.DOMParser().parseFromString(markup, 'text/html');
        var candidates = Array.from(parsed.querySelectorAll('[data-sk-recent-search-results] [data-sk-recent-product]'));
        var fragment = doc.createDocumentFragment();
        var count = 0;
        ids.forEach(function (id) {
          if (count >= 3) return;
          var product = candidates.find(function (item) { return item.dataset.skRecentProduct === id; });
          if (!product) return;
          var destination = new URL(product.getAttribute('href'), win.location.origin);
          if (destination.origin !== win.location.origin || !/\/products\/[^/]+/.test(destination.pathname)) return;
          fragment.appendChild(product.cloneNode(true)); count += 1;
        });
        if (!count) return;
        links.replaceChildren(fragment);
        panel.hidden = false;
        host.classList.add('sk-home-recent-open');
        input.setAttribute('aria-describedby', [describedBy, description.id].filter(Boolean).join(' '));
      } catch (error) { /* Failed/aborted reads leave the native search untouched. */ }
      finally { win.clearTimeout(activeTimer); }
    }
    on(input, 'focus', show);
    on(input, 'pointerdown', show);
    on(input, 'input', function () { hide(); if (!input.value.trim() && !composing) show(); });
    on(input, 'compositionstart', function () { composing = true; hide(); });
    on(input, 'compositionend', function () { composing = false; if (!input.value.trim()) show(); });
    on(input, 'keydown', function (event) {
      if (composing || event.isComposing || event.keyCode === 229 || panel.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); hide(); }
      else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        var items = links.querySelectorAll('a');
        if (!items.length) return;
        event.preventDefault(); event.stopPropagation();
        items[event.key === 'ArrowDown' ? 0 : items.length - 1].focus();
      }
    }, true);
    on(panel, 'keydown', function (event) {
      if (event.isComposing) return;
      if (event.key === 'Escape') { event.preventDefault(); hide(); focusInput(); return; }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      var items = Array.from(links.querySelectorAll('a'));
      var index = items.indexOf(doc.activeElement);
      if (index < 0) return;
      event.preventDefault();
      if (event.key === 'Home') items[0].focus();
      else if (event.key === 'End') items[items.length - 1].focus();
      else if (event.key === 'ArrowUp' && index === 0) focusInput();
      else items[Math.max(0, Math.min(items.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
    });
    on(panel.querySelector('[data-sk-recent-close]'), 'click', function () { hide(); focusInput(); });
    on(host, 'focusout', function () { win.clearTimeout(closeTimer); closeTimer = win.setTimeout(function () { if (!host.contains(doc.activeElement)) hide(); }, 0); });
    on(doc, 'pointerdown', function (event) { if (!host.contains(event.target)) hide(); });
    on(win, 'pageshow', hide);
    on(win, 'pagehide', hide);
    on(win, 'storage', function (event) { if (event.key === HISTORY_KEY || event.key === null) { hide(); if (eligible()) show(); } });
    // A cleared-query response may arrive late from Athens. Close only that stale
    // native popup; its search, keyboard handlers and results are not replaced.
    var predictive = host.querySelector('predictive-search');
    var observer;
    if (predictive && win.MutationObserver) {
      observer = new win.MutationObserver(function () {
        if (!panel.hidden && !input.value.trim() && predictive.hasAttribute('open') && typeof predictive.close === 'function') predictive.close();
      });
      observer.observe(predictive, { attributes: true, attributeFilter: ['open'] });
    }
    host.__skHomeRecent = { show: show, hide: hide, destroy: function () {
      hide(); win.clearTimeout(closeTimer); listeners.forEach(function (remove) { remove(); }); if (observer) observer.disconnect(); panel.remove(); host.classList.remove('sk-home-recent-host');
      if (originalPlaceholder === null) input.removeAttribute('placeholder'); else input.setAttribute('placeholder', originalPlaceholder);
      delete host.__skHomeRecent;
    } };
    return host.__skHomeRecent;
  }
  var api = { readRecent: readRecent, requestURL: requestURL, initHost: initHost };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.SKHomeBrowse = api;
  if (!global.document) return;
  function init() {
    if (!global.document.body.classList.contains('template-index')) return;
    if (global.document.querySelector('[data-sk-search-assist-template]')) return;
    var template = global.document.querySelector('[data-sk-home-recent-template]');
    if (!template) return;
    global.document.querySelectorAll('#header .header-search-global').forEach(function (host) { initHost(host, template, global); });
  }
  if (!global.__skHomeRecentLifecycle) {
    global.__skHomeRecentLifecycle = true;
    global.document.addEventListener('shopify:section:load', init);
    global.document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('.sk-home-recent-host').forEach(function (host) { if (host.__skHomeRecent) host.__skHomeRecent.destroy(); }); });
  }
  init();
})(typeof window === 'undefined' ? globalThis : window);
